import { getSchema, getSkus, getUrlParams } from './helpers';

export const getOrganicSkus = ({ pageContext, eventBusData, utilizeRvData }) => {
  let skus;
  if (eventBusData?.fbtSkus) {
    skus = eventBusData.fbtSkus.join();
  } else {
    skus = getSkus(pageContext, utilizeRvData);
  }

  return skus;
};

export const getViewedSku = ({ pageContext }) => {
  return pageContext?.data?.itemId;
};

export const getEventFilterIds = ({ data }) => {
  let filterId = '';

  if (data?.searchModel?.appliedDimensions) {
    data.searchModel.appliedDimensions.forEach((element) => {
      if (element.label === 'The Home Depot Events') {
        element.refinements.forEach((ref) => {
          filterId = ref.refinementKey;
        });
      }
    });
  }

  return filterId;
};

export const getCustomerType = ({ experienceContext }) => {
  let customerType = 'b2c';

  if (experienceContext?.customer?.type === 'b2b') {
    customerType = 'b2b';
  }

  return customerType;
};

export const getForceAdParam = () => {
  if (typeof window === 'undefined') return false;
  let params = getUrlParams(window?.location?.href);
  let forceAd = false;

  if (params.forceSponsoredBanner) {
    forceAd = true;
  }

  return forceAd;
};

export const setAppId = ({ experienceContext }) => {

  if (experienceContext?.isConsumerApp) {
    return 'mobileapp';
  }
  return experienceContext?.channel?.toLowerCase() === 'mobile' ? 'mobileweb' : 'desktop';
};

export const getApiParams = ({
  guestUserID, experienceContext, pageContext, schema
}) => {
  const channel = setAppId({ experienceContext });
  const customerType = experienceContext.customer?.type ? experienceContext.customer.type : 'b2c';
  const category = pageContext?.data?.searchModel?.metadata?.categoryID;
  const keyword = pageContext?.keyword;
  const customerIdentifier = guestUserID;
  const forceAd = getForceAdParam();
  const params = {
    pageType: schema,
    channel,
    customerType,
    category,
    keyword,
    customerIdentifier,
    forceAd
  };

  return params;
};
